<template>
	<v-main class="background">
		<div id="core-view">
			<v-fade-transition mode="out-in">
				<nuxt style="z-index: 10"></nuxt>
			</v-fade-transition>
		</div>
	</v-main>
</template>

<script>
export default {
	name: 'CoreView',

	metaInfo() {
		return {
			title: 'Hyosec DashBoard (Vue Material Dashboard by CreativeTim)',
		};
	},
};
</script>
